// extracted by mini-css-extract-plugin
export default {"post_text":"styles_post_text__Ah5NI"};